import React from 'react'

function Link (props) {

    const { contentState, entityKey } = props;

    const { url } = contentState.getEntity(entityKey).getData();

    return (
        <a target="_blank" href={`http://${url}`} rel="noopener noreferrer">{props.children}</a>
    );
}

export default Link;
